import { mapGetters } from "vuex";

export default {
  data() {
    return {
      valid: true
    };
  },
  computed: {
    ...mapGetters(["getDocumentRevMod"])
  },
  methods: {
    defineDocumentRevMod(mod, rpt) {
      // FORM (no generic form as this is not stored)
      let temp = {
        rpt: 0, // repeat value is blocking the increment of typing
        mod: 0, // mod from external request
        modc: 0, // current rev mod
        modm: 0, // max rannking mod
        modcc: "", // mod last/current comments
        modmc: "", // max rannking mod comment
        nmod: 0, // number of mod iterations
        nrev: 0, // number of revisions
        save: false
      };

      // INITIALISE data
      let modOrg = this.getDocumentRevMod;
      temp.rpt = 0;
      temp.mod = mod;

      // CHECK for Previous Hightest Mod
      if (modOrg === null) {
        temp.nmod = 0; // current mod
        temp.nrev = this.defineCounterNrev(mod);
        temp.save = true; // enable true
        temp.modc = 10; // current (new)
        temp.modm = 10; // maximum recorded mod (new)
        temp.rpt = 0; // initialise repetions
        temp.modcc = "Current rev. comment.";
        temp.modmc = "Max. rev. comment.";
      } else if (mod != modOrg.modc) {
        temp.nmod = this.getDocumentRevMod.nmod + 1; // update only for new
        temp.nrev = this.defineCounterNrev(mod);
        temp.save = true;
        temp.modc = mod;
        temp.rpt = rpt;
        temp.modm = modOrg.modm;
        temp.modcc = this.defineDocumentRevModComment(mod);
        temp.modmc = modOrg.modmc;
        // [LT] is mod higher ranking category
        // to ensue that Master is not overwritten by Slave
        let k0 = Math.floor(modOrg.modc);
        let k1 = Math.floor(mod);
        if (k1 < k0 || k1 == k0) {
          temp.modm = mod;
          temp.modmc = this.defineDocumentRevModComment(mod);
        }
      } else {
        temp.nmod = this.defineCounterNmod(rpt, modOrg.rpt, modOrg.nmod);
        temp.nrev = this.defineCounterNrev(mod);
        temp.save = true;
        temp.rpt = rpt;
        temp.modc = mod;
        temp.modcc = this.defineDocumentRevModComment(mod);
        temp.modm = modOrg.modm;
        temp.modmc = modOrg.modmc;
      }

      // check that modm is not undefined
      if (temp.modm === undefined) {
        temp.modm = temp.modc;
        temp.modmc = temp.modcc;
      }

      // check that modm is not undefined
      if (temp.modc === undefined) {
        temp.modc = 10;
        temp.modcc = "Undefined";
      }

      // HELP
      // console.log("");
      // console.log(">>> DOC. REV. MOD. <<<");
      // console.log(temp);
      return temp;
    },
    defineCounterNmod(rpt, rptOrg, nmodOrg) {
      let nmod = 0;
      // UPDATE mod counter
      if (this.getDocumentRevMod === null) {
        nmod = 1;
      } else if (rpt === 0) {
        nmod = this.getDocumentRevMod.nmod + 1;
      } else if (rpt === rptOrg && nmodOrg === 0) {
        nmod = this.getDocumentRevMod.nmod + 1;
      } else if (rpt !== rptOrg) {
        nmod = this.getDocumentRevMod.nmod + 1;
      } else {
        nmod = this.getDocumentRevMod.nmod;
      }
      return nmod;
    },
    defineCounterNrev(mod) {
      let nrev = 0;
      if (mod < 3) {
        nrev = this.getDocumentRevMod.nrev + 1;
      } else {
        if (this.getDocumentRevMod === null) {
          nrev = 0;
        } else {
          nrev = this.getDocumentRevMod.nrev;
        }
      }
      return nrev;
    },
    defineDocumentRevModComment(mod) {
      if (mod == 1.01) {
        return "Transformative modification.";
      } else if (mod == 1.11) {
        return "User setup.";
      } else if (mod == 1.11) {
        return "User setup.";
      } else if (mod == 1.51) {
        return "Docunemnt title change.";
      } else if (mod == 1.52) {
        return "Document ID change.";
      } else if (mod == 1.61) {
        return "Document type change";
      } else if (mod == 1.62) {
        return "Document secuirty level update.";
      } else if (mod == 1.63) {
        return "User Transform update change.";
      } else if (mod == 2.11) {
        return "User critical data mod.";
      } else if (mod == 2.12) {
        return "Data privacy signed.";
      } else if (mod == 2.14) {
        return "Company access level changed.";
      } else if (mod == 2.14) {
        return "Company access level changed.";
      } else if (mod == 2.15) {
        return "Facility access level changed.";
      } else if (mod == 2.41) {
        return "Maintenance major data update.";
      } else if (mod == 2.51) {
        return "Resource / plan imp.";
      } else if (mod == 2.61) {
        return "Safety critical data change.";
      } else if (mod == 2.71) {
        return "Type or category data change.";
      } else if (mod == 2.81) {
        return "Document status update.";
      } else if (mod == 3.11) {
        return "Document title changed.";
      } else if (mod == 3.12) {
        return "Document type changed.";
      } else if (mod == 3.13) {
        return "Asset register updated.";
      } else if (mod == 3.14) {
        return "Business impact change.";
      } else if (mod == 3.15) {
        return "Support data change.";
      } else if (mod == 3.16) {
        return "Hash tags update.";
      } else if (mod == 3.21) {
        return "Register item added.";
      } else if (mod == 3.22) {
        return "Register item removed.";
      } else if (mod == 3.51) {
        return "User minor data change.";
      } else if (mod == 3.52) {
        return "User licence request.";
      } else if (mod == 3.53) {
        return "Terms and Conditions signed.";
      } else if (mod == 3.61) {
        return "New Company structure.";
      } else if (mod == 3.62) {
        return "New business area.";
      } else if (mod == 3.63) {
        return "New company short name.";
      } else if (mod == 3.64) {
        return "New company strategy or values.";
      } else if (mod == 3.71) {
        return "Technical minor spec update.";
      } else if (mod == 3.81) {
        return "Facility minor data mod..";
      } else if (mod == 3.82) {
        return "Maintenance data mod.";
      } else if (mod == 3.83) {
        return "Asset facility data minor mod.";
      } else if (mod == 4.11) {
        return "Document description or summary change.";
      } else if (mod == 4.12) {
        return "Goal change.";
      } else if (mod == 4.13) {
        return "Scope change.";
      } else if (mod == 4.14) {
        return "Opportunity or risk type.";
      } else if (mod == 4.15) {
        return "Business driver.";
      } else if (mod == 4.16) {
        return "Relationship added.";
      } else if (mod == 4.17) {
        return "Business property changed.";
      } else if (mod == 4.18) {
        return "Date changed.";
      } else if (mod == 4.21) {
        return "Approval progress.";
      } else if (mod == 4.22) {
        return "Approval reverted.";
      } else if (mod == 4.23) {
        return "Approval on hold.";
      } else if (mod == 4.24) {
        return "Approval restarted.";
      } else if (mod == 4.31) {
        return "New role added.";
      } else if (mod == 4.32) {
        return "Role removed.";
      } else if (mod == 4.33) {
        return "Role updated.";
      } else if (mod == 4.34) {
        return "User assigned to role.";
      } else if (mod == 4.41) {
        return "Action created.";
      } else if (mod == 4.42) {
        return "Action updated.";
      } else if (mod == 4.43) {
        return "Action deleted.";
      } else if (mod == 4.51) {
        return "User non critical data change.";
      } else if (mod == 4.52) {
        return "User preferences change.";
      } else if (mod == 4.53) {
        return "User new selection.";
      } else if (mod == 4.54) {
        return "User contact details updated.";
      } else if (mod == 4.55) {
        return "User role info updated.";
      } else if (mod == 4.56) {
        return "User development changed";
      } else if (mod == 4.61) {
        return "Company non critical data change.";
      } else if (mod == 4.62) {
        return "Company preferences change.";
      } else if (mod == 4.63) {
        return "Company new selection.";
      } else if (mod == 4.64) {
        return "Company contact details updated.";
      } else if (mod == 4.65) {
        return "Company role info updated.";
      } else if (mod == 4.66) {
        return "Company description updated.";
      } else if (mod == 5.11) {
        return "Attachment added.";
      } else if (mod == 5.12) {
        return "Attachment removed.";
      } else if (mod == 5.13) {
        return "Attachment edited.";
      } else if (mod == 5.31) {
        return "Roles list item moved up.";
      } else if (mod == 5.32) {
        return "Roles list item moved down.";
      } else if (mod == 5.41) {
        return "User preferences changed.";
      } else if (mod == 5.51) {
        return "Company preferences changed.";
      } else if (mod == 5.61) {
        return "Material Order generated.";
      } else if (mod == 5.91) {
        return "General comment.";
      } else {
        return "Undefined document change.";
      }
    },
    saveDocumentRevMod(mod, rpt) {
      if (mod > 0) {
        let u = this.defineDocumentRevMod(mod, rpt);
        this.$store.dispatch("changeDocumentRevMod", u);
      }
      // HELP
      // console.log("docRevsModFunctions");
      // console.log("saveDocumentRevMod");
      // console.log(u.n);
    }
  }
};
